import styled from "styled-components";

export const Container = styled.section`
	@media screen and (min-width: 0px) {
		position: relative;
		min-height: calc(100vh - 90px);
		contain: content;
		padding: 0 1em;
		overflow-y: auto;
		/* background-image: url(${require("@/assets/img/labyes.png")
			.default});
		background-repeat: no-repeat;
		background-position: right bottom; */

		header.header {
			display: flex;
			align-items: center;
			justify-content: space-between;

			h2 {
				font-size: 0.875em;
				font-weight: 600;
				text-transform: uppercase;
				color: #333;
			}

			button {
				background: none;
				border: none;
				font-size: 0.875em;
				font-weight: bold;
				color: var(--secundary-color);
				text-decoration: underline;
			}
		}

		article.content {
			header.content__header {
				.user-image {
					display: flex;
					flex-direction: column;
					align-items: center;

					img {
						width: 80px;
						height: 80px;
						border-radius: 100%;
						margin: 0;
						object-fit: cover;
					}

					button {
						background: none;
						border: none;
						outline: none;
						margin: 0;
						font-size: 1em;
					}
				}

				.user__info {
					display: flex;
					flex-direction: column;
					align-items: center;
					margin-top: 15px;

					p {
						margin: 0;
					}

					.name {
						p {
							font-size: 18px;
							color: var(--primary-color);
							font-weight: bold;
						}
					}

					.id {
						p {
							font-size: 1em;
						}
					}
				}
			}

			div.content__body {
				margin-top: 30px;
				display: flex;
				flex-direction: column;
				align-items: center;

				table.table_info {
					width: 90vw;
					max-width: 500px;
					border-collapse: collapse;

					tbody {
						tr {
							display: flex;
							flex-direction: row;
							align-items: center;
							border-bottom: 1px solid rgb(217, 217, 217);

							td {
								flex: 1 1 auto;
								display: flex;
								flex-direction: row;
								align-items: center;
								height: 45px;

								button.add-new-pet {
									background: none;
									border: none;
									padding: 0;
									outline: 0;
								}
							}

							td:nth-of-type(1) {
								font-size: 18px;
								font-weight: bold;
								color: var(--auxiliary-color);
								justify-content: flex-start;
							}

							td:nth-of-type(2) {
								font-size: 1em;
								color: var(--auxiliary-color);
								justify-content: flex-end;
							}

							td:nth-of-type(3) {
								flex-basis: auto;
								flex-grow: 0;

								button {
									margin-left: 1em;
									background: none;
									border: none;
									padding: 0;
									outline: 0;
								}
							}
						}
					}
				}

				.profile-actions {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
					width: 500px;
					max-width: 90vw;
					margin-bottom: 25px;

					button {
						margin-top: 25px;
						max-width: 150px;
						min-width: 170px;
						padding: 0.6em 1em;

						&:first-of-type {
							padding: 0.7em 1em;
							margin-right: 1em;
						}

						/* &:last-of-type {
							margin-bottom: 25px;
						} */

						&.no-spotlight {
							font-size: 0.8em;
							background-color: var(--light);
							border-color: var(--dark);
							color: var(--dark);
						}
					}
				}
			}
		}

		article.popup-form-profile,
		article.popup-form-pets,
		article.popup-form-image-profile,
		article.popup-form-image-pet,
		article.popup-dialog {
			position: absolute;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.8);
			z-index: 1000;
			display: flex;
			flex-direction: column;
			align-items: center;
			overflow-x: auto;

			.popup-form-image-profile__content,
			.popup-form-image-pet__content {
				label.label_image {
					.button-wrapper {
						cursor: pointer;
						position: relative;
						width: 250px;
						text-align: center;
						margin: 15px auto 30px;
						display: flex;
						flex-direction: column-reverse;
						align-items: center;

						span {
							cursor: pointer;
							text-transform: capitalize;
							display: block;
							color: white;
						}

						img {
							border-radius: 50%;
							margin-bottom: 10px;
							width: 100px;
							height: 100px;
							object-fit: cover;
						}

						.require {
							margin-bottom: 10px;
						}
					}

					.button-wrapper span.label {
						position: relative;
						z-index: 0;
						display: inline-block;
						width: 100%;
						background: #00bfff;
						cursor: pointer;
						color: #fff;
						padding: 10px 0;
						text-transform: uppercase;
						font-size: 14px;
					}

					#upload {
						display: inline-block;
						position: absolute;
						z-index: 1;
						width: 100%;
						height: 50px;
						top: 0;
						left: 0;
						opacity: 0;
						cursor: pointer;
					}
				}
			}

			.popup-form-profile__content,
			.popup-form-pets__content,
			.popup-form-image-profile__content,
			.popup-form-image-pet__content,
			.popup-dialog__content {
				background: var(--white);
				width: 800px;
				max-width: 90vw;
				margin-top: 60px;
				margin-bottom: 60px;
				padding: 15px 30px;
				border-radius: 8px;

				span.require {
					color: tomato !important;
					font-size: 14px !important;
					padding-top: 2px !important;
				}

				form {
					display: flex;
					flex-direction: column;

					div {
						position: relative;
						flex: 1 1 auto;
						flex-basis: 50%;

						img.close {
							cursor: pointer;
							position: absolute;
							top: 10px;
							right: 0;
						}

						img.image_pet {
							cursor: pointer;
							position: absolute;
							left: 50%;
							top: 0;
							transform: translate(-50%, -70%);
						}

						h3 {
							text-transform: uppercase;
							font-size: 18px;
							font-weight: bold;
						}

						label {
							display: flex;
							flex-direction: column;
							margin-bottom: 1em;

							p {
								margin: 0;
								font-size: 16px;
							}

							input,
							select,
							textarea {
								width: 100%;
								border: 1px solid #b2b2b2;
								padding-left: 10px;
								height: 45px;
								line-height: 45px;

								&::placeholder {
									color: #c8c8c8;
								}
							}

							textarea {
								height: 136px;
								line-height: normal;
							}
						}

						label.inputChecked {
							flex-direction: row;
							margin-top: 1em;
							input {
								width: 20px;
								height: 20px;
								margin-right: 10px;
							}
						}

						div {
							width: 100%;
							display: flex;
							align-items: flex-start;

							&.center-items {
								align-items: center;
							}

							label {
								flex-basis: 50%;

								& + label {
									margin-left: 2em;
								}
							}

							a {
								margin-left: 2em;
							}
						}

						.block-submit {
							display: flex;
							justify-content: center;
							margin-bottom: 30px;
						}
					}
				}
			}

			.popup-dialog__content {
				dialog {
					position: relative;
					border: 0;
					background: none;
					display: flex;
					flex-direction: column;
					align-items: center;

					form {
						label {
							width: 100%;
							display: flex;
							align-items: center;

							span {
								font-size: 18px;
								margin-right: 10px;
							}

							select {
								flex: 1 1 auto;
								line-height: 30px;
								height: 30px;
								border: 1px solid #ccc;
							}
						}
					}

					menu {
						display: flex;
						margin: 0;
						padding: 0;

						button:disabled {
							cursor: default;
							opacity: 0.5;
						}

						button {
							flex: 1 1 auto;
							min-width: 80px;
						}

						button:nth-of-type(2) {
							margin-left: 15px;
						}
					}
				}
			}
		}
	}
`;
